import { addYears } from "date-fns"
import { IDateRange } from "../../utils/interfaces/DateRangeInterface"
import { toQueryString } from "../../utils/parsers/QueryString"

export class SubscriberChurnGraphicFilterModel {
    date: IDateRange = {start: new Date(2020, 0, 1), end: addYears(new Date(), 1)}

    constructor(b?:Partial<SubscriberChurnGraphicFilterModel>) {
        Object.assign(this, b)   
    }

    isFilterFilled():boolean {
        return !!this.date.start ||
            !!this.date.end
    }

    toQueryString():string {
        const tmp = {
            ...this,
            date: undefined,
            dueStartDate: this.date.start ? this.date.start!.toISOString() : undefined,
            dueEndDate: this.date.end ? this.date.end!.toISOString(): undefined, 
        }

        return toQueryString(tmp)
    }
}
